import React, { useState,memo} from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import { useTranslation } from "react-i18next";



const TreeSelect = memo(({ data, onSelect,selected }) => {
  const { t } = useTranslation();
  const [selectedNodes, setSelectedNodes] = useState(selected);
 
  const handleSelect = (currentNode, selectedNodes) => {

    setSelectedNodes(selectedNodes);
    onSelect(currentNode);
  };

  function onAction(node, action) {
    console.log('onAction::', action, node)
  }

  return (
    <DropdownTreeSelect
    data={data}
    onChange={handleSelect}
    onAction={onAction} 
    mode="multiSelect"
    showDropdown
    clearSearchOnChange
    keepTreeOnSearch
    texts={{ placeholder: t('selectCollections')  }}
    selected={selectedNodes}
    className="treeSelectStyle"
    

  />

  
  
  
  
  );
});

export default TreeSelect;
